import React, { Component } from 'react';
import ReactModal from 'react-modal';
import Select from 'react-select';
import '../assets/teachers.css';
import '../assets/custom.css'
import moment from 'moment';
import REST from '../Shared/REST';
import HeaderComponent from '../Shared/Header';
import {Redirect, withRouter } from 'react-router-dom';
import {Nav, NavItem, OverlayTrigger, Popover, Tooltip} from 'react-bootstrap';
import {isTablet} from "react-device-detect";
import logo_maze from '../assets/images/logo_maze.png';
import logo_kidspeak from '../assets/images/logo_kidspeak.png';
import logo_picturenaming from '../assets/images/app-picturenaming.png';
import logo_wordsignsay from '../assets/images/app-wordsignsay.png';
import logo_kidsign from '../assets/images/app-kidsignsay.png';
import logo_copyright from '../assets/images/app-copyright.png';
import logo_slashtest from '../assets/images/logo_slashtest.png';
import start_here_lable from '../assets/images/start_here_lable.png';
import ico_tick from '../assets/images/ico_tick.png';
import ico_cross from '../assets/images/ico_cross.png';
import logo_wordmark from '../assets/images/logo_wordmark.png';
import logo_wordmark2 from '../assets/images/logo_wordmark2.png';
import PNScoreTasks from '../assets/images/PNScoreTasks.png';
import PNPictureCards from '../assets/images/PNPictureCards.png';

import Helpers from "../Shared/Helpers";
import {prepareChartData, selectStudentScoreListTab, selectStudentTab, updateStudent, userLogout} from "./actions";
import {connect} from "react-redux";
import FooterComponent from "../Shared/Footer";
import DialogBox from "../Shared/DialogBox";
import TRACKING from "../Shared/DataTrackingPoints";
import Modal from 'react-modal';
import App_Selection_Graphic from "../assets/images/App_Selection_Graphic.png";
import How_to_select_apps from "../assets/images/How to select apps.png";
import info_icon_2f from "../assets/images/info_icon_2f.png";
import logo from "../assets/images/logo_avenuepm.png";
import ReactToPrint from 'react-to-print';
import ComponentToPrint from './ComponentToPrint';
import badge1 from '../assets/images/badge_1.png';
import badge2 from '../assets/images/badge_2.png';
import badge3 from '../assets/images/badge_3.png';
import badge4 from '../assets/images/badge_4.png';
import badge5 from '../assets/images/badge_5.png';
import badge6 from '../assets/images/badge_6.png';
import badge7 from '../assets/images/badge_7.png';

Modal.setAppElement('body');

const customStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '55%'
    }
};
const customStyleApp = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '55%'
    }
};


let addClassInstruction = null;
let addStudentInstruction = null;
let PNInstruction = null;
let WSSInstruction = null;
let CopyrightInstruction = null;
let KidsignInstruction = null;

let noticeStorage = localStorage.getItem('notice');

const tooltipReadingLevel = (
    <Tooltip id="tooltipReadingLevel">
        Estimate Reading Grade Level. Add the reading grade versus placement grade.
    </Tooltip>
);

const tooltipDisability = (
    <Tooltip id="tooltipDisability">
        Multiple Select Option
    </Tooltip>
);

const tooltipApps = (
    <Tooltip id="tooltipApps">
        Multiple Select Option
    </Tooltip>
);

const readingLevelOptions = [
    { value: '0', label: '0' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
];

const genderOptions = [
    { value: '1', label: 'Female' },
    { value: '2', label: 'Male' },
    { value: '3', label: 'Other' }
];

const languageOptions = [
    { value: '1', label: 'ASL' },
    { value: '2', label: 'Signed English' },
    { value: '3', label: 'Spoken English' },
    { value: '5', label: 'Sim-com' },
    { value: '4', label: 'Other' }
];

let disabilityOptions = [
    { value: '1', label: 'None' },
    { value: '2', label: 'Deaf' },
    { value: '3', label: 'Hard of Hearing' },
    { value: '4', label: 'Blind / Visually impaired' },
    { value: '5', label: 'Learning Disability' },
    { value: '6', label: 'Behavior Challenges' },
    { value: '7', label: 'Developmental Challenges' },
    { value: '8', label: 'Physical Challenges' }
];

const placementOptions = [

    { value: '1', label: 'General Ed' },
    { value: '2', label: 'Special Classroom' },
    { value: '3', label: 'Resource Room' },
    { value: '4', label: 'School for the Deaf' }

];

const gradeOptions = [
    { value: '0', label: 'K' },
    { value: '1', label: '1' },
    { value: '2', label: '2' },
    { value: '3', label: '3' },
    { value: '4', label: '4' },
    { value: '5', label: '5' },
    { value: '6', label: '6' },
    { value: '7', label: '7' },
    { value: '8', label: '8' },
    { value: '9', label: '9' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: 'Transition', label: 'Transition' },
    { value: 'College', label: 'College' }

];

const fourValueOptions = [
    { value: '0', label: 'No' },
    { value: '1', label: 'Yes' },
    { value: '2', label: 'Unknown' }

];

let appOptions = [

    { value: 'picturenaming', label: 'PictureNaming', isSelected: true},
    { value: 'wordsignsay', label: 'WordSign/Say', isSelected: true},
    { value: 'copyright', label: 'CopyRight', isSelected: true},
    { value: 'slash', label: 'Slash', isSelected: true},
    { value: 'kidspeak', label: 'KidSpeak', isSelected: true},
    { value: 'maze', label: 'Maze', isSelected: true},
    { value: 'kidsign', label: 'KidSign/Say', isSelected: true},
    { value: 'wordmark', label: 'WordMark', isSelected: true},

];

const getValue = (opts, val) => opts.find(o => o.value === val);
function getFourValue(opts, val) {
    if (val === '-1') return null;
    else return opts.find(o => o.value === val);
}
const resultMultipleValues = [];

class StudentsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            wordMarkScoreList: [],
            kidSpeakScoreList: [],
            pictureNamingScoreList: [],
            copyRightScoreList: [],
            activeTab: this.props.studentTab,
            studentId: this.props.student.userId,
            changeTeacher: false
        };
    }

    componentDidMount() {
        console.log('studentScoreListTab', this.props.studentScoreListTab);
        Helpers.authorize(this);
        window.onpopstate = async(e) => {
            if(e.state && e.state.key !== window.history.state.key) {
                if (this.state.activeTab > 1) {
                    await this.handleSelect(this.state.activeTab - 1);

                } else {
                    await this.props.updateStudent(null);
                    await this.props.selectStudentTab(1);
                    await this.props.selectStudentScoreListTab(0);
                }
            }
        };
        //this.props.updateStudent(this.props.student);
        console.log('studentScoreListTab2', this.props.studentScoreListTab);
    }

    handleLogout = () => {
        REST.logout().then((response) => {
            console.log('Response', response);
            if(localStorage.getItem('addClass') === 'hide'){
                addClassInstruction = localStorage.getItem('addClass');
            }
            if(localStorage.getItem('addStudent') === 'hide'){
                addStudentInstruction = localStorage.getItem('addStudent');
            }
            localStorage.removeItem('token');
            if(addClassInstruction !== null){
                localStorage.setItem('addClass',addClassInstruction);
            }
            if(addStudentInstruction !== null){
                localStorage.setItem('addStudent',addStudentInstruction);
            }
            this.props.userLogout();

            this.props.history.push("/login");
        }, (error) => {
            console.log('Error', error);
            localStorage.removeItem('token');
            localStorage.clear();
            this.props.userLogout();
            this.props.history.push("/login");
        });
    };

    handleSelect = async(selected) => {
        await this.props.selectStudentTab(selected);
        await this.props.selectStudentScoreListTab(0);
        this.setState({ activeTab: selected });
    };

    handleCancel = () => {
        this.props.history.goBack();
    };

    handleChangeTeacher = () => {
        this.setState({ changeTeacher: true });
    };

    handleCancelTransfer = () => {
        this.setState({ changeTeacher: false });
    };

    handleStudentClick = (student, classId) => {
        this.props.updateStudent(student);
        //this.props.history.push('/');
        //this.props.history.push('/teacher/student');
        this.props.history.go(0);
    };

    render() {
        return (
            <div>
                <HeaderComponent notifications={!this.props.schoolAdmin}  bugReport studentClick={this.handleStudentClick} logout={this.handleLogout} />
                <div className="section bgGrey">
                    <div className="container">
                        <div className="row">
                            {this.state.changeTeacher ?
                                <TransferStudentComponent schoolAdmin={this.props.schoolAdmin} studentId={this.props.student.id} handleCancelTransfer={this.handleCancelTransfer} />
                                :
                                <div className="col-lg-12">
                                    <Nav className="nav nav-tabs" onSelect={this.handleSelect} activeKey={this.state.activeTab} >
                                        <NavItem eventKey={1} >
                                            Student Details</NavItem>
                                        <NavItem eventKey={2} >
                                            Student Data</NavItem>
                                        {this.props.schoolAdmin?null:
                                        <NavItem eventKey={3} >
                                            Score Tasks</NavItem>}
                                    </Nav>
                                    {this.state.activeTab === 1 ? <StudentDetails selectStudentScoreListTab={this.props.selectStudentScoreListTab} selectStudentTab={this.props.selectStudentTab} updateStudent={this.props.updateStudent} student={this.props.student} schoolAdmin={this.props.schoolAdmin} classId={this.props.classId} handleChangeTeacher={this.handleChangeTeacher} handleCancel={this.handleCancel} /> : null}
                                    {this.state.activeTab === 2 ? <Data selectStudentScoreListTab={this.props.selectStudentScoreListTab} selectStudentTab={this.props.selectStudentTab}  updateStudent={this.props.updateStudent} student={this.props.student} schoolAdmin={this.props.schoolAdmin}/> : null}
                                    {this.state.activeTab === 3 ? <StudentScore
                                        selectStudentTab={this.props.selectStudentTab}
                                        selectStudentScoreListTab={this.props.selectStudentScoreListTab}
                                        studentScoreListTab={this.props.studentScoreListTab}
                                        updateStudent={this.props.updateStudent}
                                        student={this.props.student}
                                        wordMarkScore={this.state.wordMarkScoreList}
                                        kidSpeakScore={this.state.kidSpeakScoreList}
                                        pictureNamingScore={this.state.pictureNamingScoreList}
                                        copyRightScore={this.state.copyRightScoreList}
                                    /> : null}
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <FooterComponent/>
            </div >
        );
    }
}

const actionToProps = dispatch => {
    return {
        updateStudent: async(student) => await dispatch(updateStudent(student)),
        selectStudentTab:async(selectedTab) => await dispatch(selectStudentTab(selectedTab)),
        selectStudentScoreListTab:async(selectedScoreListTab) => await dispatch(selectStudentScoreListTab(selectedScoreListTab)),
        userLogout: async() => await dispatch(userLogout())
    };
};


const mapStateToProps = state => ({
    student: state.teacherReducer.student,
    studentTab:state.teacherReducer.studentTab,
    studentScoreListTab:state.teacherReducer.studentScoreListTab,
    schoolAdmin: state.teacherReducer.schoolAdmin
});

export default connect(mapStateToProps,actionToProps)(StudentsComponent)

class StudentDetailsComponent extends Component {

    constructor(props) {
        super(props);
        if (!this.props.student || !this.props.classId) {
            return;
        }
        this.state = {
            firstname: this.props.student.user.firstname,
            lastname: this.props.student.user.lastname,
            email: this.props.student.parent ? this.props.student.parent.email: '',
            loginID: this.props.student.userId,
            password: this.props.student.user.password,
            gender: this.props.student.gender,
            gradeLevel: this.props.student.gradeLevel,
            language: this.props.student.language,
            disability: this.props.student.disability,
            apps: this.props.student.apps,
            screeningLevel: this.props.student.screeningLevel,
            placement: this.props.student.placement,
            multipleValues: this.getInitialMultipleValues(this.props.student.disability.toString()),
            multipleValues1: [],
            specialNeedsData: this.props.student.specialNeedsData,
            freeLunch: this.props.student.freeLunch,
            ell: this.props.student.ell,
            title1: this.props.student.title1,
            research: this.props.student.research === 'true' || this.props.student.research === '1' ? true : false,
            parentId: this.props.student.parent ? this.props.student.parent.id: null,
            parent: this.props.student.parent,
            firstNameError: '',
            lastNameError: '',
            passwordError: '',
            readingLevelError: '',
            genderError: '',
            languageError: '',
            disabilityError: '',
            placementError: '',
            gradeError: '',
            emailWarning: '',
            errorEmail: '',
            errorNote: '',
            modalDialog: false,
            responseContent: '',
            excludeVid: false,
            showAppIntro:false,
            analytics: {
                type: null,
                metadata: null,
            }
        };
        this.handleName = this.handleName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.handleEmail = this.handleEmail.bind(this);
        this.handleLoginID = this.handleLoginID.bind(this);
        this.handleGender = this.handleGender.bind(this);
        this.handleReadingLevel = this.handleReadingLevel.bind(this);
        this.handleGrade = this.handleGrade.bind(this);
        this.handleLanguage = this.handleLanguage.bind(this);
        this.handleDisability = this.handleDisability.bind(this);
        this.handleFreeLunch = this.handleFreeLunch.bind(this);
        this.handleELL = this.handleELL.bind(this);
        this.handlePlacement = this.handlePlacement.bind(this);
        this.handleSpecialEd = this.handleSpecialEd.bind(this);
        this.handleTitle1 = this.handleTitle1.bind(this);
        this.handleResearch = this.handleResearch.bind(this);
        this.handleAppChange = this.handleAppChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleChangeTeacher = this.handleChangeTeacher.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
        this.handleExcludeVid = this.handleExcludeVid.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.handleAppIntroduction = this.handleAppIntroduction.bind(this);
        this.closeAppIntro = this.closeAppIntro.bind(this);
        this.getInitialMultipleValues = this.getInitialMultipleValues.bind(this);
    }
    componentDidMount() {
    }

    getInitialMultipleValues(values) {
        let valueArray = values.split(',');
        let multipleValues = [];
        for (let i = 0; i < valueArray.length; i++){
            multipleValues.push(getValue(disabilityOptions, valueArray[i]));
        }
        if(multipleValues.length==0){
            multipleValues.push(getValue(disabilityOptions, 1));
        }
        return multipleValues;
    }

    getMultipleValues(values) {
        let valueArray = values.split(',');
        for (let i = 0; i < valueArray.length; i++){
            this.state.multipleValues.push(getValue(disabilityOptions, valueArray[i]));
        }
        return false;
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    async handleExcludeVid(event) {
        this.setState({ excludeVid: event.target.checked, apps: null });
        if(event.target.checked == true){
            appOptions = [
                { value: 'slash', label: 'Slash', isSelected: true},
                { value: 'kidspeak', label: 'KidSpeak', isSelected: true},
                { value: 'maze', label: 'Maze', isSelected: true},
                { value: 'wordmark', label: 'WordMark', isSelected: true},
            ];
            let values = [];
            for (let opt of appOptions){
                values.push(opt.value);
            }
            await this.setState({ apps: values.join(",")});
            await this.handleAppChange(appOptions);
        }
        else{
            appOptions = [
                { value: 'picturenaming', label: 'PictureNaming', isSelected: true},
                { value: 'wordsignsay', label: 'WordSign/Say', isSelected: true},
                { value: 'copyright', label: 'CopyRight', isSelected: true},
                { value: 'slash', label: 'Slash', isSelected: true},
                { value: 'kidspeak', label: 'KidSpeak', isSelected: true},
                { value: 'maze', label: 'Maze', isSelected: true},
                { value: 'kidsign', label: 'KidSign', isSelected: true},
                { value: 'wordmark', label: 'WordMark', isSelected: true},
            ];
            let values = [];
            for (let opt of appOptions){
                values.push(opt.value);
            }
            await this.setState({ apps: values.join(",")});
            await this.handleAppChange(appOptions);
        }
    }

    handleName(event) {
        this.setState({ firstname: event.target.value });
    }

    handleLastName(event) {
        this.setState({ lastname: event.target.value });
    }

    handlePassword(event) {
        this.setState({ password: event.target.value });
    }

    handleEmail(event) {
        this.setState({email: event.target.value});
        if(event.target.value.length === 0){
            this.setState({email: null, errorEmail: '', emailWarning: '' });
        }
        else {
            if (!this.validateEmail(event.target.value)){
                this.setState({errorEmail: 'validationRed', emailWarning: 'Email address format is invalid' });
            }
            else {
                this.setState({email: event.target.value, emailWarning: '', errorEmail: ''});
            }
        }
    }

    handleLoginID(event) {
        this.setState({ loginID: event.target.value });
    }

    handleLanguage(event) {
        this.setState({ language: event.value });
    }

    handleReadingLevel(event) {
        this.setState({ screeningLevel: event.value });
    }

    async handleDisability(event) {

        let options = event;
        let value = [];
        if(options&&options.length === 0){
            disabilityOptions = [
                { value: '1', label: 'None' },
                { value: '2', label: 'Deaf' },
                { value: '3', label: 'Hard of Hearing' },
                { value: '4', label: 'Blind / Visually impaired' },
                { value: '5', label: 'Learning Disability' },
                { value: '6', label: 'Behavior Challenges' },
                { value: '7', label: 'Developmental Challenges' },
                { value: '8', label: 'Physical Challenges' }
            ];
        }
        if(options){
            for (let i=0, l = options.length; i < l; i++){

                if(options[i].value == 1){
                    disabilityOptions = [{ value: '1', label: 'None' }];
                    value = [];
                    value.push(1);
                }
                else{
                    disabilityOptions = [
                        { value: '2', label: 'Deaf' },
                        { value: '3', label: 'Hard of Hearing' },
                        { value: '4', label: 'Blind / Visually impaired' },
                        { value: '5', label: 'Learning Disability' },
                        { value: '6', label: 'Behavior Challenges' },
                        { value: '7', label: 'Developmental Challenges' },
                        { value: '8', label: 'Physical Challenges' }
                    ];
                    value.push(options[i].value);
                }
            }
            await this.setState({ disability: value.join(",") });
            this.getMultipleValues(this.state.disability.toString());
        }
    }

    async handleAppChange(value) {
        let values = [];
        for (let opt of value){
            values.push(opt.value);
        }
        await this.setState({ apps: values.join(","), multipleValues1: value});

    }

    handleGrade(event) {
        this.setState({ gradeLevel: event.value });
    }

    handleGender(event) {
        this.setState({ gender: event.value });
    }

    handlePlacement(event) {
        this.setState({ placement: event.value });
    }

    handleELL(event) {
        this.setState({ ell: event === null ? '-1' : event.value });
    }

    handleFreeLunch(event) {
        this.setState({ freeLunch: event === null ? '-1' : event.value });
    }

    handleSpecialEd(event) {
        this.setState({ specialNeedsData: event === null ? '-1' : event.value });
    }

    handleTitle1(event) {
        this.setState({ title1: event === null ? '-1' : event.value});
    }

    handleResearch(event) {
        this.setState({ research: !event.target.checked });
    }

    async handleRemoveParent(event){
        let confirmed = window.confirm("Are you sure that you want to remove the parent?");
        if(confirmed) {
            await REST.deleteParent(this.state.loginID);
            await this.setState({
                parentId: null,
                parent: null,
                email: '',
                modalDialog: true,
                responseContent:'The parent has been removed.'
            });
            setTimeout(() => {
                this.setState({modalDialog: false});
                this.handleCancel();
            }, 2000);
        }
    }

    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    validate() {
        let valid = true;
        if (this.state.firstname === '') {
            valid = false;
            this.setState({ firstNameError:'firstNameError' });
        }
        else {
            this.setState({ firstNameError:''});
        }
        if (this.state.lastname.length === 0){
            valid = false;
            this.setState({ lastNameError:'lastNameError' });
        }
        else {
            this.setState({ lastNameError:'' });
        }
        if(!this.state.email || this.state.email === ''){
            this.setState({email: null, errorEmail: '', emailWarning: '' });
        }
        else {
            if (!this.validateEmail(this.state.email)){
                this.setState({errorEmail: 'validationRed', emailWarning: 'Email address format is invalid' });
                valid = false;
            }
            else {
                this.setState({emailWarning: '', errorEmail: ''});
            }
        }
        if (this.state.password.length === 0) {
            valid = false;
            this.setState({ passwordError:'passwordError' });
        }
        else {
            this.setState({ passwordError:'' });
        }
        if (this.state.screeningLevel === null){
            valid = false;
            this.setState({ readingLevelError:'readingLevelError' });
        }
        else {
            this.setState({ readingLevelError:'' });
        }
        if (this.state.gender === null){
            valid = false;
            this.setState({ genderError:'genderError' });
        }
        else {
            this.setState({ genderError:'' });
        }
        if (this.state.language === null){
            valid = false;
            this.setState({languageError:'languageError' });
        }
        else {
            this.setState({languageError:'' });
        }
        if (this.state.disability === null || this.state.disability.length === 0) {
            valid = false;
            this.setState({ disabilityError:'disabilityError' });
        }
        else {
            this.setState({ disabilityError:'' });
        }
        if (this.state.placement === null ){
            valid = false;
            this.setState({ placementError:'placementError' });
        }
        else {
            this.setState({ placementError:'' });
        }
        if (this.state.gradeLevel === null){
            valid = false;
            this.setState({ gradeError:'gradeError' });
        }
        else {
            this.setState({ gradeError:'' });
        }
        return valid;
        //TODO: check email for regex
    }

    handleSave(event) {
        if (this.validate()) {
            this.setState({ errorNote: '' });
            let user = this.state;
            user['userId'] = this.props.student.userId;
            REST.updateStudent(user).then((response) => {
                if (response.ok) {
                    this.setState({
                        modalDialog: true,
                        responseContent: 'Student Details Successfully Updated'
                    });
                    this.setState({
                            analytics: {
                                type: TRACKING.TEACHER_STUDENT_DETAILS_SAVE_CHANGES,
                                metadata: {userId: this.props.student.userId}
                            }
                        },
                        () => this.handleAnalytics());
                    setTimeout(() => {
                        this.setState({modalDialog: false});
                        this.handleCancel();
                    }, 2000);
                }else if(response.statusText=="Unauthorized"){
                    this.setState({
                        modalDialog: true,
                        responseContent: response.msg?response.msg:'Failed to save. Only the student’s teacher can change this information.'
                    });
                }else{
                    this.setState({
                        modalDialog: true,
                        responseContent: response.msg?response.msg:'Failed to save. The parent email may have been used before.'
                    });
                }
            }, (error) => {
                console.log('Error new student', error);
            });

        }
        else {
            this.setState({ errorNote: 'Fields with red outline have to be filled in or selected!' });
        }
    }

    handleCancel(event) {
        this.props.updateStudent(null);
        this.props.handleCancel();
    }

    handleDelete(event) {
        REST.deleteStudent(this.state.loginID).then((response) => {
            if (response.success) {
                this.setState({
                    modalDialog: true,
                    responseContent:'Student successfully deleted'
                });
                setTimeout(()=>{this.setState({modalDialog:false});this.handleCancel();},3500);
            } else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
    }

    async handleChangeTeacher(event) {
        await this.setState({
                analytics:{
                    type:TRACKING.TEACHER_STUDENT_DETAILS_CHANGE_TEACHER_CLICK,
                    metadata:{userId: this.props.student.userId}
                }
            },
            () => this.handleAnalytics());
        this.props.handleChangeTeacher();
    }

    handleBackClick(event) {
        this.props.updateStudent(null);
        this.props.selectStudentTab(1);
        this.props.selectStudentScoreListTab(0);
        this.props.history.goBack();
    }

    handleAppIntroduction(){
        this.setState({showAppIntro:true});
    }
    closeAppIntro(){
        this.setState({showAppIntro:false});
    }



    render() {
        if (!this.props.student || !this.props.classId) {
            return <Redirect to="/login" />
        }

        let appsPreselect = appOptions.map(e=>{if(this.state.apps.split(",").includes(e.value)){ return e} });

        return (
            <div >
                    <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />

                    <ReactModal isOpen={this.state.showAppIntro} style={{customStyleApp}}>
                        <div style={{width: '100%'}}>
                            <div className="row" style={{width:250, float:'right'}}>
                                <div className="col-md-3" style={{marginTop:30}}>
                                    <a  onClick={this.closeAppIntro} className="handBtn"><span>Close</span></a>
                                </div>
                                <div className="col-md-3" style={{marginLeft:50,marginTop:30}}>
                                    <a  onClick={this.printAppIntro} className="handBtn" href={"https://docs.google.com/document/d/1LuRBxc0aFzkC0sLe_xvfxCXrTZxPJHD70s1WhxFMKEI/edit?usp=sharing"}><span>Print</span></a>
                                </div>
                            </div>
                        </div>
                        <div style={{marginTop:100,marginLeft:50}} >

                            <ComponentToPrint ref={el => (this.componentRef = el)} />
                        </div>

                    </ReactModal>
                <div className="col-lg-12 solidBorder">
                    <div style={{color:'red',paddingLeft:15}}>{this.state.errorNote}</div>
                    <form id="formAddStudent">
                        <div className="col-sm-4">
                            <label htmlFor="inputStudentName">First Name</label>
                            <input type="text" defaultValue={this.state.firstname} onChange={this.handleName} id="inputStudentName" className={this.state.firstNameError + " form-control inputStyle1"} placeholder="First Name" required autoFocus />
                            <label htmlFor="inputStudentLastName">Last Name</label>
                            <input type="text" defaultValue={this.state.lastname} onChange={this.handleLastName} id="inputStudentLastName" className={this.state.lastNameError + " form-control inputStyle1"} placeholder="Last Name" required />
                            <label htmlFor="inputStudentLoginID">User Number</label>
                            <input type="text" defaultValue={this.state.loginID} onChange={this.handleLoginID} id="inputStudentLoginID" className="form-control inputStyle1" placeholder="User Number" disabled />
                            <label htmlFor="inputStudentPassword">Password</label>
                            <input type="text" defaultValue={this.state.password} onChange={this.handlePassword} id="inputStudentPassword" className={this.state.passwordError + " form-control inputStyle1"} placeholder="Password" required />
                            <label htmlFor="inputStudentReadingLevel">Reading Level</label>
                            <OverlayTrigger placement="top" overlay={tooltipReadingLevel}>
                                <Select  onChange={this.handleReadingLevel} defaultValue={getValue(readingLevelOptions, this.state.screeningLevel)} id="inputStudentReadingLevel" className={this.state.readingLevelError} options={readingLevelOptions} isSearchable={false} />
                            </OverlayTrigger>
                            <label htmlFor="inputStudentGender">Gender</label>
                            <Select  onChange={this.handleGender} id="inputStudentGender"  defaultValue={getValue(genderOptions, this.state.gender)} options={genderOptions} isSearchable={false} className={this.state.genderError} />

                        </div>
                        <div className="col-sm-4">
                            <label htmlFor="inputStudentLanguage">Language</label>
                            <Select  onChange={this.handleLanguage} id="inputStudentLanguage" options={languageOptions} defaultValue={getValue(languageOptions, this.state.language)} className={this.state.languageError} isSearchable={false} />

                            <label htmlFor="inputStudentDisability">Student Description</label>
                            <OverlayTrigger placement="top" overlay={tooltipDisability}>
                                <Select  onChange={this.handleDisability} id="inputStudentDisability" defaultValue={this.state.multipleValues} className="basic-multi-select" options={disabilityOptions} className={this.state.disabilityError} isMulti={true} isSearchable={false} />
                            </OverlayTrigger>

                            <label htmlFor="inputStudentPlacement">Placement</label>
                            <Select  onChange={this.handlePlacement} id="inputStudentPlacement" defaultValue={getValue(placementOptions, this.state.placement)} options={placementOptions} className={this.state.placementError} isSearchable={false} />

                            <label htmlFor="inputStudentGrade">Grade Placement</label>
                            <Select  onChange={this.handleGrade} id="inputStudentGrade" className={this.state.gradeError} defaultValue={getValue(gradeOptions, this.state.gradeLevel)} options={gradeOptions} isSearchable={false} />

                            {this.state.parentId?<div>
                                <label htmlFor="inputParentId">Parent User Number (<a onClick={() => {this.handleRemoveParent()}}>Remove Parent</a>)</label>
                                <input type="text" id="inputParentId" value={this.state.parent.userId} className={"form-control inputStyle1"} placeholder="ParentId" disabled={"true"} />
                                <label htmlFor="inputStudentEmail">Parent Email</label>
                                <input type="text" value={this.state.email} onChange={this.handleEmail} id="inputStudentEmail" className={this.state.errorEmail + " form-control inputStyle1"} placeholder="Email" required disabled/>
                            </div>:
                            <div>
                                <label htmlFor="inputStudentEmail">Parent Email</label>
                                <input type="text" value={this.state.email} onChange={this.handleEmail} id="inputStudentEmail" className={this.state.errorEmail + " form-control inputStyle1"} placeholder="Email" required />
                            </div>}
                        </div>
                        <div className="col-sm-4">
                            <label htmlFor="inputStudentIEP">IEP (Optional)</label>
                            <Select  onChange={this.handleSpecialEd} id="inputStudentSpecialEd" defaultValue={getFourValue(fourValueOptions, this.state.specialNeedsData)} options={fourValueOptions} isSearchable={false} isClearable={true} />
                            <label htmlFor="inputStudentELL">ELL (Optional)</label>
                            <Select  onChange={this.handleELL} id="inputStudentELL" defaultValue={getFourValue(fourValueOptions, this.state.ell)} options={fourValueOptions} isSearchable={false} isClearable={true}/>
                            <label htmlFor="inputStudentFreeLunch">Free Lunch (Optional)</label>
                            <Select  onChange={this.handleFreeLunch} id="inputStudentFreeLunch" defaultValue={getFourValue(fourValueOptions, this.state.freeLunch)} options={fourValueOptions} isSearchable={false} isClearable={true}/>
                            <label htmlFor="inputStudentTitle1">Title 1 (Optional)</label>
                            <Select  onChange={this.handleTitle1} id="inputStudentTitle1" defaultValue={getFourValue(fourValueOptions, this.state.title1)} options={fourValueOptions} isSearchable={false} isClearable={true}/><br />

                            <label htmlFor="Research" className="cb"><input type="checkbox" onChange={this.handleResearch} name="Research" checked={!this.state.research} id="Research" /><span className="checkmark"></span> Exclude Student Data</label><br />
                            <label htmlFor="ExcludeVideoApps" className="cb" style={{marginBottom:0}}><input type="checkbox" onChange={this.handleExcludeVid} name="ExcludeVideoApps" value={this.state.excludeVid} id="ExcludeVideoApps" /><span className="checkmark"></span> Exclude Video Apps</label>
                            <div style={{color:'red', paddingBottom:10}}>{this.state.emailWarning}</div>
                        </div>
                        <div className={"col-md-12 "} style={{marginTop:10}}>
                            <div className="row" style={{marginLeft:5}}>
                                <label htmlFor="inputStudentApps">Task Apps</label>
                            </div>
                            <div className="row">
                                <div className="col-sm-4" style={{height:40,marginTop:-30, marginLeft:90, cursor:'pointer'}}>
                                    <img src={info_icon_2f} style={{width:22, height:22}} onClick={this.handleAppIntroduction}/>
                                    <a target="_blank" href={"https://docs.google.com/document/d/1LuRBxc0aFzkC0sLe_xvfxCXrTZxPJHD70s1WhxFMKEI/edit?usp=sharing"} style={{fontFamily:'Open Sans', fontSize:'1.00em'}} name="How" className="btn btn-link" >How to Select Apps</a>
                                </div>
                            </div>
                            <OverlayTrigger placement="top" overlay={tooltipApps}>
                                <Select className="basic-multi-select" isMulti={true} onChange={this.handleAppChange.bind(this)}options={appOptions} value={appsPreselect} isSearchable={false} />
                            </OverlayTrigger>
                        </div>
                    </form>
                    <div className="clearfix"></div>
                    <div className="divBottomRelative tr">
                        <hr />
                        <a onClick={this.handleBackClick} className="backArrow fl">
                            <span>Back to Students' List</span>
                        </a>
                        <a onClick={this.handleCancel} className="handBtn">
                            <span>Cancel</span>
                        </a>
                        <a onClick={() => { this.handleSave() } } className="handBtn">
                            <span>Save Changes</span>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}
const StudentDetails = withRouter(StudentDetailsComponent);

class StudentData extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalDialog:false,
            responseContent:'',
            pnTypeModel:false,
            noDataModel:false,
            analytics: {
                type: null,
                metadata: null,
            }}
        this.handleBackClick = this.handleBackClick.bind(this);
        this.handleTutorial = this.handleTutorial.bind(this);
        this.handleMazeClick = this.handleMazeClick.bind(this);
        this.handleSlashTestClick = this.handleSlashTestClick.bind(this);
        this.handleWordMarkClick = this.handleWordMarkClick.bind(this);
        this.handleWordMark2Click = this.handleWordMark2Click.bind(this);
        this.handleKidSpeakClick = this.handleKidSpeakClick.bind(this);
        this.handlePictureNamingClick = this.handlePictureNamingClick.bind(this);
        this.handlePNTypeClose = this.handlePNTypeClose.bind(this);
        this.handleChoosePNComputerModel = this.handleChoosePNComputerModel.bind(this);
        this.handleChoosePN1On1Model = this. handleChoosePN1On1Model.bind(this);
        this.handleChoosePNManualModel = this. handleChoosePNManualModel.bind(this);
        this.handleCopyRightClick = this.handleCopyRightClick.bind(this);
        this.handleWordSignSayClick = this.handleWordSignSayClick.bind(this);
        this.handleKidSignClick = this.handleKidSignClick.bind(this);
        this.handleNoDataClose = this.handleNoDataClose.bind(this);
        this.handleAnalytics = this.handleAnalytics.bind(this);
    }

    handleBackClick(event) {
        this.props.updateStudent(null);
        this.props.selectStudentTab(1);
        this.props.selectStudentScoreListTab(3);
        if(this.props.schoolAdmin){
            this.props.history.push("/school-admin");
        }else {
            this.props.history.push("/teacher");
        }
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleTutorial(event) {
        this.setState({
            modalDialog: true,
            responseContent:'To Be Added'
        });
        setTimeout(()=>{this.setState({modalDialog:false})},3500);
    }

    async handleMazeClick(event) {
        await this.setState({
            analytics: {
                type: TRACKING.MAZE_DATACHART_VIEW,
                metadata: {userId: this.props.student.userId}
            }
        })
        this.handleAnalytics();
        await REST.checkStudentData(this.props.student.userId, "Maze").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/maze');
            }
        });

    }

    async handleWordMarkClick(event) {
        await this.setState({
            analytics: {
                type: TRACKING.WM_DATACHART_VIEW,
                metadata: {userId: this.props.student.userId}
            }
        })
        this.handleAnalytics();
        await REST.checkStudentData(this.props.student.userId, "WordMark").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/wordmark');
            }
        });
    }

    async handleWordMark2Click(event) {
        await this.setState({
            analytics: {
                type: TRACKING.WM_DATACHART_VIEW,
                metadata: {userId: this.props.student.userId}
            }
        })
        this.handleAnalytics();
        await REST.checkStudentData(this.props.student.userId, "WordMark2").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/wordmark2');
            }
        });
    }

    async handleSlashTestClick(event) {
        await this.setState({
            analytics: {
                type: TRACKING.SLASH_DATACHART_VIEW,
                metadata: {userId: this.props.student.userId}
            }
        })
        this.handleAnalytics();
        await REST.checkStudentData(this.props.student.userId, "Slash").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/slashtest');
            }
        });
    }

    async handleKidSpeakClick(event) {
        await this.setState({
            analytics: {
                type: TRACKING.KS_DATACHART_VIEW,
                metadata: {userId: this.props.student.userId}
            }
        })
        this.handleAnalytics();
        await REST.checkStudentData(this.props.student.userId, "KidSpeak").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/kidspeak');
            }
        });
    }

    async handlePictureNamingClick(event) {

        this.setState({
            pnTypeModel:true
        });

    }

    async handlePNTypeClose(event){
        this.setState({
            pnTypeModel:false
        });
    }

    async handleChoosePNComputerModel(event){
        await this.setState({
            analytics: {
                type: TRACKING.PN_DATACHART_VIEW,
                metadata: {userId: this.props.student.userId, PNModel: 'Computer'}
            }
        })
        this.handleAnalytics();
        await REST.checkStudentData(this.props.student.userId, "PictureNaming/Computer").then(res=> {
            if (res.body === 0) {
                this.setState({
                    pnTypeModel:false,
                    noDataModel:true

                });
            } else {
                this.props.history.push('/teacher/student/data/picturenaming/computer');
            }
        });
    }

    async handleChoosePN1On1Model(event){
        await this.setState({
            analytics: {
                type: TRACKING.PN_DATACHART_VIEW,
                metadata: {userId: this.props.student.userId, PNModel: '1On1'}
            }
        })
        this.handleAnalytics();
        await REST.checkStudentData(this.props.student.userId, "PictureNaming/1On1").then(res=> {
            if (res.body === 0) {
                this.setState({
                    pnTypeModel:false,
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/picturenaming/1On1');
            }
        });
    }

    async handleChoosePNManualModel(event){
        await this.setState({
            analytics: {
                type: TRACKING.PN_DATACHART_VIEW,
                metadata: {userId: this.props.student.userId, PNModel: 'Manual'}
            }
        })
        this.handleAnalytics();
        await REST.checkStudentData(this.props.student.userId, "PictureNaming/Manual").then(res=> {
            if (res.body === 0) {
                this.setState({
                    pnTypeModel:false,
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/picturenaming/manual');
            }
        });
    }

    async handleCopyRightClick(event) {
        await this.setState({
            analytics: {
                type: TRACKING.CR_DATACHART_VIEW,
                metadata: {userId: this.props.student.userId}
            }
        })
        this.handleAnalytics();
        await REST.checkStudentData(this.props.student.userId, "CopyRight").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/copyright');
            }
        });
    }

    async handleWordSignSayClick(event) {
        await this.setState({
            analytics: {
                type: TRACKING.WSS_DATACHART_VIEW,
                metadata: {userId: this.props.student.userId}
            }
        })
        this.handleAnalytics();
        await REST.checkStudentData(this.props.student.userId, "WordSign/Say").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/wordsignsay');
            }
        });
    }

    async handleKidSignClick(event) {
        await this.setState({
            analytics: {
                type: TRACKING.KSS_DATACHART_VIEW,
                metadata: {userId: this.props.student.userId}
            }
        })
        this.handleAnalytics();
        await REST.checkStudentData(this.props.student.userId, "KidSign").then(res=> {
            if (res.body === 0) {
                this.setState({
                    noDataModel:true
                });
            } else {
                this.props.history.push('/teacher/student/data/kidsign');
            }
        });
    }

    async handleNoDataClose(event){
        this.setState({
            noDataModel:false
        });
    }

    render() {
        return (
            <div className="tab-pane solidBorder" >
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                {/*<p className="tc">Select from the apps menu to view related data.</p>*/}
                <div className={"col-md-2 col-xs-12"}>
                    <div style={{paddingTop:15}}>
                        <a onClick={this.handleBackClick} className="backArrow fl">
                            <span>Back to Students' List</span>
                        </a>
                    </div>
                </div>
                <div className={"col-md-8 col-xs-12"}>
                    <ul className="nav nav-pills pill-sm" style={{marginTop:10}}>
                        <li onClick={this.handlePictureNamingClick}>
                            <a>
                                <img src={logo_picturenaming} alt="Picture Naming" border="0" />
                                {this.props.student.user.student_score_state&&this.props.student.user.student_score_state.pnLevel > 12 ?
                                    <img src={badge7} style={{position:'absolute', right:-20, bottom:-20}} />:
                                    null}
                            </a>
                        </li>
                        <li onClick={this.handleWordSignSayClick}>
                            <a>
                                <img src={logo_wordsignsay} alt="Word Sign/Say" border="0" />
                                {this.props.student.user.student_score_state&&this.props.student.user.student_score_state.wssLevel > 1 ?
                                    <img src={badge4} style={{position:'absolute', right:-20, bottom:-20}} />:
                                    null}
                            </a>
                        </li>
                        <li onClick={this.handleCopyRightClick}>
                            <a>
                                <img src={logo_copyright} alt="Copy Right" border="0" />
                                {this.props.student.user.student_score_state&&this.props.student.user.student_score_state.crLevel > 6 ?
                                    <img src={badge1} style={{position:'absolute', right:-20, bottom:-20}} />:
                                    null}
                            </a>
                        </li>
                        <li onClick={this.handleSlashTestClick}>
                            <a>
                                <img src={logo_slashtest} alt="Slash Test" border="0" />
                                {this.props.student.user.student_score_state&&this.props.student.user.student_score_state.slashLevel > 8 ?
                                    <img src={badge3} style={{position:'absolute', right:-20, bottom:-20}} />:
                                    null}
                            </a>
                        </li>
                        <li onClick={this.handleKidSpeakClick}>
                            <a>
                                <img src={logo_kidspeak} alt="Kid Speak" border="0" />
                                {this.props.student.user.student_score_state&&this.props.student.user.student_score_state.ksLevel > 12 ?
                                    <img src={badge2} style={{position:'absolute', right:-20, bottom:-20}} />:
                                    null}
                            </a>
                        </li>
                        <li onClick={this.handleMazeClick}>
                            <a>
                                <img src={logo_maze} alt="Maze" border="0" />
                                {this.props.student.user.student_score_state&&this.props.student.user.student_score_state.mazeLevel > 12 ?
                                <img src={badge5} style={{position:'absolute', right:-20, bottom:-20}} />:
                                    null}
                            </a>
                        </li>
                        <li onClick={this.handleKidSignClick}>
                            <a>
                                <img src={logo_kidsign} alt="KidSign" border="0" />
                                {this.props.student.user.student_score_state&&this.props.student.user.student_score_state.kssLevel > 12 ?
                                    <img src={badge6} style={{position:'absolute', right:-20, bottom:-20}} />:
                                    null}
                            </a>
                        </li>
                        <li onClick={this.handleWordMarkClick}>
                            <a>
                                <img src={logo_wordmark} alt="Word Mark" border="0" />
                            </a>
                        </li>
                        <li onClick={this.handleWordMark2Click}>
                            <a>
                                <img src={logo_wordmark2} alt="Word Mark2" border="0" />
                            </a>
                        </li>

                    </ul>
                </div>
                <div className={"col-md-2 col-xs-12"}>
                    <h3 style={{textAlign:'right',paddingTop:20,fontSize:'1.25em'}}>{this.props.student !== null ? this.props.student.user.firstname : null} {this.props.student !== null ? this.props.student.user.lastname : null}</h3>
                </div>
                <div className={"row"}>
                    <div className="divBottomRelative col-md-12 tr">
                        <hr />
                    </div>
                </div>
                <Modal isOpen={this.state.noDataModel} style={customStyle}>
                    <div className="modal-content content">
                        <div className="modal-header">
                            <div className="clearfix"></div>
                            <h2>No tasks completed yet.</h2>
                        </div>
                        <div className="modal-footer">
                            <a onClick={this.handleNoDataClose} className="handBtn"><span>Close</span></a>
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={this.state.pnTypeModel} style={customStyle}>
                    <div className="modal-content content">
                        <div className="modal-header">
                            <div className="clearfix"></div>
                            <h2>PictureNaming Data Chart</h2>
                        </div>
                        <div className={"modal-body"}>
                            <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                            <div className="row">
                                <div className="col-md-12 bgGrey roundCorners">
                                    <h4>Please choose the type of PictureNaming assessments</h4>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12" style={{"marginBottom":10, "marginTop":10}}>
                            <a onClick={this.handleChoosePNComputerModel} className="handBtn" type="submit"><span>Computer Tasks</span></a>
                            <a onClick={this.handleChoosePNManualModel} className="handBtn" type="submit"><span>Manual Tasks</span></a>
                            <a onClick={this.handlePNTypeClose} className="handBtn"><span>Close</span></a>
                        </div>
                        <div className="modal-footer">
                            <div className="col-md-3"></div>
                            <div className="col-md-4"></div>
                            <div className="col-md-4"></div>
                        </div>
                    </div>
                </Modal>
            </div >
        );
    }
}
const Data = withRouter(StudentData);

const StudentScore = withRouter(class StudentScore extends Component {

    constructor(props) {
        super(props);
        this.handleBackClick = this.handleBackClick.bind(this);
        this.state = {
            showData: this.props.studentScoreListTab,
            wordMarkScoreList: [],
            wordMark2ScoreList: [],
            kidSpeakScoreList: [],
            pictureNamingScoreList: [],
            copyRightScoreList:[],
            wordSignSayScoreList:[],
            kidSignScoreList:[],
            student:this.props.student,
            modalDialog:false,
            responseContent: '',
            pnScoreModel:false,
            pnTypeModel:true,
            noDataModel:false,
            analytics: {
                type: null,
                metadata: null,
            }
        };

        this.handleAnalytics = this.handleAnalytics.bind(this);
        this.handlePNScoreTasks = this.handlePNScoreTasks.bind(this);
        this.handlePNClose = this.handlePNClose.bind(this);

    }

    componentDidMount() {
        REST.listWordMarkScore(this.state.student.user.id).then((response) => {
            if (response.success) {
                this.setState({ wordMarkScoreList: response.body });
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
        REST.listWordMark2Score(this.state.student.user.id).then((response) => {
            if (response.success) {
                this.setState({ wordMark2ScoreList: response.body });
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
        REST.listKidSpeakScore(this.state.student.user.id).then((response) => {
            if (response.success) {
                this.setState({ kidSpeakScoreList: response.body });
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
        REST.listPictureNamingScores(this.state.student.user.id).then((response) => {
            if (response.success) {
                this.setState({ pictureNamingScoreList: response.body });
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
        REST.listCopyRightScores(this.state.student.user.id).then((response) => {
            if (response.success) {
                this.setState({ copyRightScoreList: response.body });
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
        REST.listWordSignSayScores(this.state.student.user.id).then((response) => {
            if (response.success) {
                this.setState({ wordSignSayScoreList: response.body });
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });
        REST.listKidSignScores(this.state.student.user.id).then((response) => {
            if (response.success) {
                this.setState({ kidSignScoreList: response.body });
            }
            else {
                this.setState({
                    modalDialog: true,
                    responseContent:response.msg
                });
                setTimeout(()=>{this.setState({modalDialog:false})},3500);
            }
        }, (error) => {
            this.setState({
                modalDialog: true,
                responseContent:error.msg
            });
            setTimeout(()=>{this.setState({modalDialog:false})},3500);
        });

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleAnalytics(){
        let analytics = this.state.analytics;
        REST.addAnalytics(analytics).then(res => {});
    }

    handleSelect(tabNum){
        this.props.selectStudentScoreListTab(tabNum);
        this.setState({showData: tabNum})
    }
    handlePNScoreTasks(){
        this.props.selectStudentScoreListTab(3);
        this.setState({showData: 3});
        this.setState({pnScoreModel: false})
    }
    handlePNClose(){
        this.setState({
            pnScoreModel:false
        });
    }

    start1to1PNSession(){
        let userId = this.state.student.user.id;
        this.props.history.push("/teacher/apps/pn-1-1?userId="+userId);
    }

    startManualPNSession(){
        let userId = this.state.student.user.id;
        this.props.history.push("/teacher/apps/pn-manual?userId="+userId);
    }

    handleHowToScore(){
        let tutorialAddress = "";
        switch(this.state.showData){
            case 1: //WordMark
                tutorialAddress = " https://docs.google.com/document/d/1o0Rfhf9dsDVuYzWKuxw9uJtNp48gvTL5uk0GWxcS5A0/edit?usp=sharing";
                break;
            case 2: //KidSpeak
                tutorialAddress = "https://docs.google.com/document/d/1ZyVBeuvXxtdbFbr9p8UC684TwNywYRUUhC7Q6BJFgjc/edit?usp=sharing";
                break;
            case 3: //PictureNaming
                tutorialAddress = "https://docs.google.com/document/d/1qtp2qimrtDn4ahX2Z0YEoWu-EwlZr-T0U0RR-04SwvE/edit?usp=sharing";
                break;
            case 4: //CopyRight
                tutorialAddress = " https://docs.google.com/document/d/1x_guMkt1cS7_IBPnum4vde0XzCk-PZ3etpl1dzNPz_c/edit?usp=sharing";
                break;
            case 5: //WordSign
                tutorialAddress = "https://docs.google.com/document/d/1EY5aqLFDoDdWF5QSt5uTWY4uX2lFWk899D1J1Cesp2k/edit?usp=sharing";
                break;
            case 6: //KidSign
                tutorialAddress = " https://docs.google.com/document/d/1pzuldFa3wFmmj8UNkxcOhYkRphnho8X4mDJmbCE9gx0/edit?usp=sharing";
                break;
        }
        this.setState({
                analytics: {
                    type: TRACKING.HOW_TO_SCORE,
                    metadata: {resourceId: this.state.showData},
                }
            },
            ()=> this.handleAnalytics());
        window.open(tutorialAddress);
    }

    handleBackClick(event) {
        this.props.updateStudent(null);
        this.props.selectStudentTab(1);
        this.props.selectStudentScoreListTab(1);
        if(this.props.schoolAdmin){
            this.props.history.push("/school-admin");
        }else {
            this.props.history.push("/teacher");
        }
    }

    render() {
        let items = null;
        let gradingTitle,gradingDescription = "";
        if (this.state.showData === 0) {
            gradingTitle = "";
            gradingDescription ="";

        }
        else if (this.state.showData === 1) {
            gradingTitle = "WordMark Score, Review or Edit";
            gradingDescription ="";
            let list = this.state.wordMarkScoreList;
            console.log("wm list");
            console.log(list);
            if(list) {
                let minIndex = -1;
                let minId = 99999999;
                for (let i = 0; i <= list.length - 1; i++) {
                    list[i].firstUnrated = false;
                    if (list[i].testId < minId && list[i].gradingDate == null) {
                        minId = list[i].testId;
                        minIndex = i;
                    }
                }
                for (let i = 0; i <= list.length - 1; i++) {
                    if(i==minIndex)
                        list[i].firstUnrated = true;
                    else
                        list[i].firstUnrated = false;
                }

            }
            items = list.map((item) => {
                return <SSIGOTO key={item.testId} score={item} type={"wm-grading"} firstUnrated={item.firstUnrated}/>
            });
        }
        else if (this.state.showData === 7) {
            gradingTitle = "WordMark2 Score, Review or Edit";
            gradingDescription ="";
            let list = this.state.wordMark2ScoreList;
            console.log("wm list");
            console.log(list);
            if(list) {
                let minIndex = -1;
                let minId = 99999999;
                for (let i = 0; i <= list.length - 1; i++) {
                    list[i].firstUnrated = false;
                    if (list[i].testId < minId && list[i].gradingDate == null) {
                        minId = list[i].testId;
                        minIndex = i;
                    }
                }
                for (let i = 0; i <= list.length - 1; i++) {
                    if(i==minIndex)
                        list[i].firstUnrated = true;
                    else
                        list[i].firstUnrated = false;
                }

            }
            items = list.map((item) => {
                return <SSIGOTO key={item.testId} score={item} type={"wm2-grading"} firstUnrated={item.firstUnrated}/>
            });
        }
        else if (this.state.showData === 2){
            gradingTitle = "KidSpeak Score, Review or Edit";
            gradingDescription ="";
            let list = this.state.kidSpeakScoreList;
            console.log("KS list");
            console.log(list);
            if(list) {
                let minIndex = -1;
                let minId = 99999999;
                for (let i = 0; i <= list.length - 1; i++) {
                    list[i].firstUnrated = false;
                    if (list[i].testId < minId && list[i].gradingDate == null) {
                        minId = list[i].testId;
                        minIndex = i;
                    }
                }
                for (let i = 0; i <= list.length - 1; i++) {
                    if(i==minIndex)
                        list[i].firstUnrated = true;
                    else
                        list[i].firstUnrated = false;
                }

            }
            items = list.map((item) => {
                return <SSIGOTO key={item.testId} score={item} type={"ks-grading"} firstUnrated={item.firstUnrated}/>
            });
        }
        else if (this.state.showData === 3){
            gradingTitle = "PictureNaming Score, Review or Edit";
            gradingDescription ="";
            let list = this.state.pictureNamingScoreList;
            if(list) {
                let minIndex = -1;
                let minId = 99999999;
                for (let i = 0; i <= list.length - 1; i++) {
                    list[i].firstUnrated = false;
                    if (list[i].testId < minId && list[i].gradingDate == null) {
                        minId = list[i].testId;
                        minIndex = i;
                    }
                }
                for (let i = 0; i <= list.length - 1; i++) {
                    if(i==minIndex)
                        list[i].firstUnrated = true;
                    else
                        list[i].firstUnrated = false;
                }

            }
            items = list.map((item) => {
                return <SSIGOTO key={item.testId} score={item} type={"pn-grading"} firstUnrated={item.firstUnrated}/>
            });
        }
        else if (this.state.showData === 4){
            gradingTitle = "CopyRight Score, Review or Edit";
            gradingDescription ="";
            let list = this.state.copyRightScoreList;
            if(list) {
                let minIndex = -1;
                let minId = 99999999;
                for (let i = 0; i <= list.length - 1; i++) {
                    list[i].firstUnrated = false;
                    if (list[i].testId < minId && list[i].gradingDate == null) {
                        minId = list[i].testId;
                        minIndex = i;
                    }
                }
                console.log("minId");
                console.log(minId);
                console.log(minIndex);
                for (let i = 0; i <= list.length - 1; i++) {
                    if(i==minIndex)
                        list[i].firstUnrated = true;
                    else
                        list[i].firstUnrated = false;
                }
                console.log("firstUnrated");
                console.log(list);

            }
            items = list.map((item) => {
                return <SSIGOTO key={item.testId} score={item} type={"cr-grading"} firstUnrated={item.firstUnrated}/>
            });
        }
        else if (this.state.showData === 5){
            gradingTitle = "Word Sign/Say Score, Review or Edit";
            gradingDescription ="";
            let list = this.state.wordSignSayScoreList;
            if(list) {
                let minIndex = -1;
                let minId = 99999999;
                for (let i = 0; i <= list.length - 1; i++) {
                    list[i].firstUnrated = false;
                    if (list[i].testId < minId && list[i].gradingDate == null) {
                        minId = list[i].testId;
                        minIndex = i;
                    }
                }
                for (let i = 0; i <= list.length - 1; i++) {
                    if(i==minIndex)
                        list[i].firstUnrated = true;
                    else
                        list[i].firstUnrated = false;
                }

            }
            items = list.map((item) => {
                return <SSIGOTO key={item.testId} score={item} type={"wss-grading"} firstUnrated={item.firstUnrated}/>
            });

            let unratedItems = items.filter(function (item){
                return item.props.score.gradingDate == null;
            });
            unratedItems = unratedItems.sort((a,b) =>
                (parseInt(a.key) < parseInt(b.key)? 1: ((parseInt(a.key) > parseInt(b.key)) ? -1: 0))
            );
            let ratedItems = items.filter(function (item){
                return item.props.score.gradingDate != null;
            });
            ratedItems = ratedItems.sort((a,b) =>
                (parseInt(a.key) < parseInt(b.key)? 1: ((parseInt(a.key) > parseInt(b.key)) ? -1: 0))
            );
            items = unratedItems.concat(ratedItems);
        }
        else if (this.state.showData === 6){
            gradingTitle = "Kid Sign/Say Score, Review or Edit";
            gradingDescription ="";
            let list = this.state.kidSignScoreList;
            console.log("KSS list");
            console.log(list);
            if(list) {
                let minIndex = -1;
                let minId = 99999999;
                for (let i = 0; i <= list.length - 1; i++) {
                    list[i].firstUnrated = false;
                    if (list[i].testId < minId && list[i].gradingDate == null) {
                        minId = list[i].testId;
                        minIndex = i;
                    }
                }

                for (let i = 0; i <= list.length - 1; i++) {
                    if(i==minIndex)
                        list[i].firstUnrated = true;
                    else
                        list[i].firstUnrated = false;
                }
            }
            items = list.map((item) => {
                return <SSIGOTO key={item.testId} score={item} type={"kss-grading"} firstUnrated={item.firstUnrated} />
            });
        }

        let unratedItems = items?items.filter(function (item){
            return item.props.score.gradingDate == null;
        }):null;
        unratedItems = unratedItems?unratedItems.sort((a,b) =>
            (parseInt(a.key) < parseInt(b.key)? 1: ((parseInt(a.key) > parseInt(b.key)) ? -1: 0))
        ):null;
        let ratedItems = items?items.filter(function (item){
            return item.props.score.gradingDate != null;
        }):null;
        ratedItems = items?ratedItems.sort((a,b) =>
            (parseInt(a.key) < parseInt(b.key)? 1: ((parseInt(a.key) > parseInt(b.key)) ? -1: 0))
        ):null;
        items = items?unratedItems.concat(ratedItems):null;

        return (
            <div className="tab-pane solidBorder hasDivBottom">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <Modal isOpen={this.state.pnScoreModel} style={customStyle}>
                    <div className="modal-content content">
                        <div className="modal-header">
                            <div className="clearfix"></div>
                            <h2>PictureNaming</h2>
                        </div>
                        <div className={"modal-body"}>
                            <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                            <div className="row">
                                <div className="col-md-12 bgGrey roundCorners">
                                    <div style={{fontSize:18}}>Chose Option:</div>
                                    <div className="row" style={{"marginBottom":200, "marginTop":50}}>
                                        <div className="col-sm-6" style={{position:'absolute'}}>
                                            <a style={{marginLeft:150}} onClick={this.handlePNScoreTasks}  type="submit"><span style={{fontWeight:'bold',fontSize:18}}>Score Tasks</span></a>
                                            <div style={{marginLeft:150,marginTop:0}}>Score or review tasks</div>
                                        </div>
                                        <div  style={{position:'absolute',marginLeft:400}}>
                                            <a style={{marginLeft:70,position:'absolute'}} onClick={this.startManualPNSession.bind(this)}  type="submit"><span style={{fontWeight:'bold',fontSize:18}}>Picture Cards</span></a>
                                            <div style={{marginLeft:70,marginTop:30}}>Start New Task <br/>using printed Picture <br/>Cards with student</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <img style={{marginLeft:100, marginTop:-400}} src={PNScoreTasks} />
                                        <img style={{marginLeft:260, marginTop:-400}} src={PNPictureCards} />
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="modal-footer">
                            <div className="col-md-3"></div>
                            <div className="col-md-4"> <a onClick={this.handlePNClose} className="handBtn"><span>Close</span></a></div>
                            <div className="col-md-4"></div>
                        </div>
                    </div>
                </Modal>
                {/*<p className="tc">Select from the apps menu to view related score tasks.</p>*/}
                <div className={"col-md-3 col-xs-12"}>
                    <div style={{paddingTop:15}}>
                        <a onClick={this.handleBackClick} className="backArrow fl">
                            <span>Back to Students' List</span>
                        </a>
                    </div>
                </div>
                <div className={"col-md-6 col-xs-12"}>
                    <ul className="nav nav-pills pill-sm" style={{marginTop:10}}>
                        <li className={this.state.showData===3 ? "active" : ""}>
                            <a data-toggle="pill" onClick={(e) => this.handleSelect(3)}>
                                <img src={logo_picturenaming} alt="Picture Naming" border="0" />
                            </a>
                        </li>
                        <li className={this.state.showData===5 ? "active" : ""}>
                            <a data-toggle="pill" onClick={(e) => this.handleSelect(5)}>
                                <img src={logo_wordsignsay} alt="Word Sign/Say" border="0" />
                            </a>
                        </li>
                        <li className={this.state.showData===4 ? "active" : ""}>
                            <a data-toggle="pill" onClick={(e) => this.handleSelect(4)}>
                                <img src={logo_copyright} alt="Copy Right" border="0" />
                            </a>
                        </li>
                        <li className={this.state.showData===2 ? "active" : ""}>
                            <a data-toggle="pill" onClick={(e) => this.handleSelect(2)}>
                                <img src={logo_kidspeak} alt="Kid Speak" border="0" />
                            </a>
                        </li>
                        <li className={this.state.showData===6 ? "active" : ""}>
                            <a data-toggle="pill" onClick={(e) => this.handleSelect(6)}>
                                <img src={logo_kidsign} alt="KidSign" border="0" />
                            </a>
                        </li>
                        <li className={this.state.showData === 1 ? "active" : ""}>
                            <a data-toggle="pill" onClick={(e) => this.handleSelect(1)}>
                                <img src={logo_wordmark} alt="Word Mark" border="0"/>
                            </a>
                        </li>
                        <li className={this.state.showData === 7 ? "active" : ""}>
                            <a data-toggle="pill" onClick={(e) => this.handleSelect(7)}>
                                <img src={logo_wordmark2} alt="Word Mark2" border="0"/>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className={"col-md-3 col-xs-12"}>
                    <h3 style={{paddingTop:20, textAlign:'right',fontSize:'1.25em'}}>{this.props.student !== null ? this.props.student.user.firstname : null} {this.props.student !== null ? this.props.student.user.lastname : null}</h3>
                </div>
                <div className={"row"}>
                    <div className={"col-md-12"}>
                        <div className="tab-content">
                            <div id="tab_maze" className="tab-pane fade in active">
                                <div className={"pull-left"}>
                                    <h3>{gradingTitle}</h3>
                                    <p>{gradingDescription}</p>
                                </div>
                                {this.state.showData === 0 ?<h4 style={{ textAlign:'center'}}>Select an app for scoring</h4>:<div className={"pull-right"}>
                                    {this.state.showData === 3 ?
                                    <a onClick={this.startManualPNSession.bind(this)}
                                       className="handBtn active"
                                    >
                                        <span>Picture Cards</span>
                                    </a>:null}

                                    <a onClick={this.handleHowToScore.bind(this)}
                                       className="handBtn active"
                                    >
                                        <span>How to Score</span>
                                    </a>

                                </div>}

                                {this.state.showData === 0 ?null:<table cellPadding="0" cellSpacing="0" border="0" width="100%" className="tableScoring">
                                    <thead>
                                    <tr className="clickable-row">
                                        <th className="fitWidth">#</th>
                                        <th>Test Date</th>
                                        <th>Date Scored</th>
                                        {this.state.showData===3?<th>Type</th>:null}
                                        {this.state.showData===1||this.state.showData===7?<th>Scored</th>:<th>Achieved Criteria</th>}
                                    </tr>
                                    </thead>
                                    <tbody>{items}</tbody>
                                </table>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

class StudentScoreItem extends Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        console.log('OnClick', this.props.score);
        event.preventDefault();
        let goto;
        if(this.props.type==="pn-grading" && this.props.score.assessmentType === 2) {
            goto = `/teacher/apps/pn-manual?userId=${this.props.score.userId}&testId=${this.props.score.testId}`;
        }else{
            goto = `apps/${this.props.type}?testId=${this.props.score.testId}`;
        }
        this.props.history.push(goto);
    }

    render() {
        let gradeDate = moment(this.props.score.gradingDate).format("YYYY-MM-DD");
        let testDate = moment(this.props.score.testDate).format("YYYY-MM-DD");
        if (gradeDate == "Invalid date"){
            gradeDate = "";
        }
        if (testDate == "Invalid date"){
            testDate = "";
        }
        return (
            <tr className="clickable-row" style={{background:'#a5c58b' }}  onClick={this.handleClick}>
                <td className="fitWidth">{this.props.score.testId}</td>
                <td>{ testDate }</td>
                {this.props.firstUnrated ? <td> <img src={start_here_lable}/> </td>:<td>{ gradeDate }</td>
                }
                {this.props.type==="pn-grading"?<td>
                    {
                        this.props.score.assessmentType === 1 ? <div>1-1 Computer Task</div> :
                            this.props.score.assessmentType === 2 ? <div>Picture Cards</div>:<div>Computer Task</div>
                    }
                </td>:null
                }
                <td>
                    {
                        this.props.score.gradingDate ? this.props.score.meetCriteria||this.props.type=="wm-grading"||this.props.type=="wm2-grading"? <img src={ico_tick} alt="Graded" className="ico-xs" /> :<img src={ico_cross} alt="Graded" className="ico-xs" /> : null
                    }
                </td>
            </tr>
        );
    }
}

const SSIGOTO = withRouter(StudentScoreItem);

const TransferStudentComponent = withRouter(class TransferStudentComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            teacherId: 0,
            classId: 0,
            studentId: this.props.studentId,
            classes: [],
            share: false,
            modalDialog:false,
            responseContent: ''
        };
        this.handleDone = this.handleDone.bind(this);
        this.handleCancelTransfer = this.handleCancelTransfer.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
    }


    handleBackClick = () => {
        if(this.props.schoolAdmin){
            this.props.history.push("/school-admin");
        }else {
            this.props.history.push("/teacher");
        }
    }

    handleCorrectTeacherData = (data) => {
        this.setState({ teacherId: data.teacher.id, classes: data.teacher.classes });
    };

    handleCancelTransfer = () => {
        this.props.handleCancelTransfer();
    };

    handleClassSelect = (classId) => {
        this.setState({ classId: parseInt(classId) });
    };

    async handleDone(event,share) {
        if (window.confirm('Are you sure you wish to save these changes?')) {
            delete this.state.classes;
            await this.setState({share:share});
            let label = this.state.share ? "Share" : "Transfer";
            REST.transferStudent(this.state).then((response) => {
                console.log(label+' student', response);
                this.setState({
                    modalDialog: true,
                    responseContent:`Student ${label} Successful!`
                });
                setTimeout(()=>{this.setState({modalDialog:false}); this.handleBackClick();},3500);
            }, (error) => {
                console.log(`${label} student error`, error);
            });
        }
    }

    render() {
        return (
            <div className="col-lg-6 solidBorder">
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <TeacherInfoTransferComponent correctTeacherData={this.handleCorrectTeacherData} handleCancelTransfer={this.handleCancelTransfer} />
                {this.state.classes && this.state.classes.length > 0 ?
                    <div>
                        <TeacherClassTransferComponent classes={this.state.classes} handleClassSelect={this.handleClassSelect} />
                        <div className="clearfix"></div>
                        <div className="divBottomRelative">
                            <hr />
                            <a onClick={this.handleCancelTransfer} className="handBtn">
                                <span>Cancel</span>
                            </a>
                            <a onClick={(e)=>this.handleDone(e,false)} disabled={this.state.classId === 0} className="handBtn">
                                <span>Transfer</span>
                            </a>
                            <a onClick={(e)=>this.handleDone(e,true)} disabled={this.state.classId === 0} className="handBtn">
                                <span>Share</span>
                            </a>
                        </div>
                    </div> :null
                }
            </div>
        )
    }
});

class TeacherInfoTransferComponent extends Component {

    constructor(props) {
        super(props);
        this.state = { firstName: '', lastName: '', teacherId: '', hideButtons: false, modalDialog:false, responseContent:'' };
        this.handleFirstName = this.handleFirstName.bind(this);
        this.handleLastName = this.handleLastName.bind(this);
        this.handleLoginID = this.handleLoginID.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
    }

    handleFirstName(event) {
        this.setState({ firstName: event.target.value.replace(/\s+/g, '') });
    }

    handleLastName(event) {
        this.setState({ lastName: event.target.value.replace(/\s+/g, '') });
    }

    handleLoginID(event) {
        event.target.value = event.target.value.replace(/[^0-9.]+/g, '');
        this.setState({ teacherId: event.target.value });
    }

    validate(){
        let valid = true;
        if (this.state.firstName.length === 0) {
            valid = false;
            document.getElementById("inputTeacherName").classList.add('validationRed');

        } else {
            document.getElementById("inputTeacherName").classList.remove('validationRed');
        }
        if (this.state.lastName.length === 0) {
            valid = false;
            document.getElementById("inputTeacherLastName").classList.add('validationRed');
        } else {
            document.getElementById("inputTeacherLastName").classList.remove('validationRed');
        }
        if (this.state.teacherId.length === 0 || this.state.teacherId === null) {
            valid = false;
            document.getElementById("inputTeacherLoginID").classList.add('validationRed');
        }
        else {
            document.getElementById("inputTeacherLoginID").classList.remove('validationRed');
        }
        return valid;

    }

    handleContinue(event) {
        if (this.validate()) {
            document.getElementById("validWarning").classList.add("hidden");
            this.listExternalTeacher();
        }
        else {
            document.getElementById("validWarning").classList.remove("hidden");
        }
    }

    listExternalTeacher() {
        REST.listExternalTeacher(this.state).then((response) => {
            if (response.success && response.body) {
                this.props.correctTeacherData(response.body);
                this.setState({ hideButtons: true });
            } else if (response.success){
                this.setState({
                    modalDialog: true,
                    responseContent:'This teacher doesn\'t have any classes.'
                });
            }else{
                this.setState({
                    modalDialog: true,
                    responseContent:'Incorrect input! Check it and retry!'
                });
            }

        }, (error) => {
            console.log('Error', error);
        });
    }

    handleCancel(event) {
        this.props.handleCancelTransfer();
    }

    render() {
        return (
            <div>
                <DialogBox notificationModal modalOpen={this.state.modalDialog} sectionContent={this.state.responseContent} closeClick={(active)=>{this.setState({modalDialog: active});}} />
                <h2>Share a student with a Teacher</h2><br />
                <p>You can share this student or move the student to another teacher.
                    First, enter the new teacher's first name, last name and user number for AvePM.
                    Then you will be asked to select the new class name for the student.
                </p>
                <form>
                    <div id={"validWarning"} className={"hidden"} style={{color:'red',paddingBottom:10}}> Fields with red outline have to be filled in or selected!</div>
                    <label htmlFor="inputTeacherName">Teacher First Name</label>
                    <input type="text" onChange={this.handleFirstName} id="inputTeacherName" className="form-control " placeholder="First Name" required autoFocus />
                    <label htmlFor="inputTeacherLastName">Teacher Last Name</label>
                    <input type="text" onChange={this.handleLastName} id="inputTeacherLastName" className="form-control " placeholder="Last Name" required />
                    <label htmlFor="inputTeacherLoginID">Teacher User Number</label>
                    <input type="text" onInput={this.handleLoginID} id="inputTeacherLoginID" className="form-control " placeholder="User Number" required />
                </form>
                <div className="clearfix"></div>
                {this.state.hideButtons ? null :
                    <div className="divBottomRelative">
                        <hr />
                        <a onClick={this.handleCancel} className="handBtn">
                            <span>Cancel</span>
                        </a>
                        <a onClick={this.handleContinue} className="handBtn">
                            <span>Continue</span>
                        </a>
                    </div>
                }
            </div>
        )
    }
}

class TeacherClassTransferComponent extends Component {
    constructor(props) {
        super(props);
        this.state = { classes: this.props.classes || [] };
        this.handleClassSelect = this.handleClassSelect.bind(this);
    }

    handleClassSelect(event) {
        this.props.handleClassSelect(event.value);
    }

    render() {
        let options = [];
        options[0] = <option key={0} value={0}>Select a class</option>
        for (var i = 0; i < this.state.classes.length; i++) {
            let c = this.state.classes[i];
            // options[i + 1] = <option key={c.id} value={c.id}>{c.name}</option>;
            options.push({ value: c.id, label: c.name});
        }
        return (
            <div>
                <p style={{marginTop:5}}>In the drop down list, select a class into which the student will be placed.</p>
                <Select onChange={this.handleClassSelect} id="classes" name="classes"   options={options} isSearchable={false} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/TeachersComponent/Students.js